export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8721.85889fb6.jpg";